// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart-container {\n  position:relative\n}\n.no-data {\n    font-size: 16px;\n    display: flex;\n    justify-content: center;\n}\n/* .chart-container {\n  max-height: 588px;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  border-radius: 4px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.highcharts-markers {\n  display: none;\n}\n\n.highcharts-root {\n  padding: 0px;\n}\n\n.make-bold {\n  font-weight: 600;\n} */\n", ""]);
// Exports
module.exports = exports;
